import { adminAuth } from "@/db/firebase/admin";
import { auth, db } from "@/db/firebase/client";
import { useAuthStore } from "@/store/useAuthStore";
import {
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signOut,
  updateProfile,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";

export const loginWithEmail = async (email: string, password: string) => {
  const cred = await signInWithEmailAndPassword(auth, email, password);

  const idToken = await cred.user.getIdToken(true);
 
  const res = await fetch("/api/auth/session/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ idToken }),
  });

  console.log(res);
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.error || "Failed to create session");
  }

  return cred.user;
};

export const registerWithEmail = async (
  email: string,
  password: string,
  extra: { name: string; dob: Date }
) => {
  const userCredential = await createUserWithEmailAndPassword(
    auth,
    email,
    password
  );

  if (auth.currentUser) {
    await updateProfile(auth.currentUser, {
      displayName: extra.name,
    });
  }

  await setDoc(doc(db, "users", userCredential.user.uid), {
    name: extra.name,
    dob: extra.dob.toISOString().split("T")[0],
    email,
    createdAt: new Date(),
  });

  return userCredential.user;
};

export const checkUser = async (email: string) => {
  const res = await fetch("/api/auth/check-user", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });

  const data = await res.json();
  return data.exists;
};

export const resetPassword = async (email: string) => {
  await sendPasswordResetEmail(auth, email);
  return true;
};

export const logout = async () => {
  useAuthStore.setState({ user: null, profile: null });
  useAuthStore.persist.clearStorage();

  try {
    await Promise.all([
      fetch("/api/auth/session/logout", { method: "POST" }),
      signOut(auth)
    ]);
  } catch (e) {
    console.warn("Cleanup calls failed", e);
  }
};
